module.exports = __webpack_public_path__ + "static/media/take_away.a86a8f18.png";